import { useEffect, useState } from "react";
import api from "@/lib/api";

const POLL_MS = 30000;

// Public, unauthenticated — derives an online/away/offline status for the chat widget
// from how recently any staff member last heartbeated (see useStaffHeartbeat).
export function useChatPresence() {
  const [status, setStatus] = useState("offline");

  useEffect(() => {
    let cancelled = false;

    const poll = async () => {
      try {
        const { data } = await api.get("/chat/presence");
        if (!cancelled) setStatus(data.status || "offline");
      } catch {
        // keep last known status on a transient error — don't flash to "offline"
      }
    };

    poll();
    const interval = setInterval(poll, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  return status;
}
